import { render, staticRenderFns } from "./Transaction3.vue?vue&type=template&id=5b056683&scoped=true&"
import script from "./Transaction3.vue?vue&type=script&lang=js&"
export * from "./Transaction3.vue?vue&type=script&lang=js&"
import style0 from "./Transaction3.vue?vue&type=style&index=0&id=5b056683&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b056683",
  null
  
)

export default component.exports